<template>
  <div class="container">
    <Head msg="Welcome to Your Vue.js App"/>
    <img style="width:100%;height:300px;" src="./../assets/image/back/huiyuanzhongxin_back.jpg" alt="">
    <div class="content">
      <div class="login">
        <div class="title">会员登录</div>
        <div class="logininput">
          <div>
            <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
              <el-form-item prop="username">
                <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
              </el-form-item>
              <div class="loginbutton1">
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="handleLogin" style="width:40%">登录</el-button>   
                  <el-button type="danger" @click="handleRegister" style="width:40%">注册</el-button>
                           
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <Footer msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";
import { isvalidUsername } from "@/utils/validate";
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入正确的用户名"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (!/^\S{8,20}$/.test(value)) {
        callback(new Error("请输入8-20位密码"));
      } else {
        callback();
      }
    };
    return {
      name: "login",
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
      },
      isClose: true,
      loading: false,
      pwdType: "password"
    };
  },
  methods: {
    handleRegister(){
      this.$router.push("/register");
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("Login", this.loginForm)
            .then(() => {
              this.loading = false;
              let redirect = decodeURIComponent(
                this.$route.query.redirect || "/"
              );
              this.$router.push({
                //你需要接受路由的参数再跳转
                path: redirect
              });
            })
            .catch(error => {
              this.loading = false;
              const response = error && error.response;
              const message = response && response.data && (response.data.message || response.data.msg);
              this.$message.error(message || "登录失败，请检查用户名、密码及本地服务状态");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {
    Head,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  position: relative;
  min-height: 100%;
  box-sizing: border-box;
  .content {
    width: 1200px;
    height: 500px;
    margin: 50px auto;
    padding-top: 0px;
    background: url(./../assets/image/huiyaun_bac.jpg) no-repeat;
    .login {
      height: 300px;
      width: 800px;
      margin: 0 auto;
      //margin-left: 200px;

      padding-top: 150px;

      .title {
        line-height: 50px;
        font-size: 24px;
        margin-top: -100px;
        text-align: left;
        padding-left: 100px;
        //margin-bottom: 0px;
      }
      .logininput {
        width: 300px;
        padding-left: 0px;
        //padding-right: 80px;
        // margin: 0 auto;
      }
      .loginbutton {
        width: 200px;
        padding-left: 140px;
      }
      .loginbottom {
        font-size: 14px;
        padding-left: 80px;
        .link {
          color: #225592;
        }
      }
    }
  }
}

@media (max-width: 767.98px) {
  .container .content {
    width: 100% !important;
    height: auto !important;
    margin: 10px 0 !important;
    background-size: cover;
  }
  .container .content .login {
    width: 100% !important;
    height: auto !important;
    padding-top: 60px !important;
  }
  .container .content .login .title {
    padding-left: 10px !important;
    margin-top: 0 !important;
  }
  .container .content .login .logininput {
    width: 100% !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
  .container .content .login .loginbutton {
    width: 100% !important;
    padding-left: 0 !important;
  }
  .container .content .login .loginbottom {
    padding-left: 10px !important;
  }
}
</style>
